import localStorage, { TABLE_NAMES } from "@/db/operation";
const db = localStorage.getInstance();

class OperationLocalDbService {
  /**
   * Deletes all records from the local database.
   * @returns {Promise<void>} A promise that resolves when all records are deleted.
   */
  async deleteAllRecords() {
    await Promise.allSettled(
      db.tables.map(async table => {
        return await db.table(table.name).clear();
      })
    );
  }

  // OPERATIONS
  async getOperationConfigurationsFromLocalDB() {
    return await db[TABLE_NAMES.OPERATIONS].toArray();
  }

  async setOperationConfigurationsToLocalDB(
    operations // : Operation[]
  ) {
    await db[TABLE_NAMES.OPERATIONS].clear();
    return await db[TABLE_NAMES.OPERATIONS].bulkPut(operations);
  }

  // OPERATION_ACCOUNTS
  async getOperationAccountsFromLocalDB() {
    return await db[TABLE_NAMES.OPERATION_ACCOUNTS].toArray();
  }

  async setOperationAccountsToLocalDB(
    operationAccounts // : OperationAccount[]
  ) {
    await db[TABLE_NAMES.OPERATION_ACCOUNTS].clear();
    return await db[TABLE_NAMES.OPERATION_ACCOUNTS].bulkPut(operationAccounts);
  }

  // OPERATION_COLUMNS
  async getOperationColumnsFromLocalDB() {
    return await db[TABLE_NAMES.OPERATION_COLUMNS].toArray();
  }

  async setOperationColumnsToLocalDB(
    operationWorkflows // : OperationWorkflow[]
  ) {
    await db[TABLE_NAMES.OPERATION_COLUMNS].clear();
    return await db[TABLE_NAMES.OPERATION_COLUMNS].bulkPut(operationWorkflows);
  }

  // OPERATION_VESSELS
  async getOperationVesselsFromLocalDB() {
    return await db[TABLE_NAMES.OPERATION_VESSELS].toArray();
  }

  async setOperationVesselsToLocalDB(
    operationVessels // : OperationVessel[]
  ) {
    await db[TABLE_NAMES.OPERATION_VESSELS].clear();
    return await db[TABLE_NAMES.OPERATION_VESSELS].bulkPut(operationVessels);
  }

  // OPERATION_WORKFLOWS
  async getOperationWorkflowsFromLocalDB() {
    return await db[TABLE_NAMES.OPERATION_WORKFLOWS].toArray();
  }

  async setOperationWorkflowsToLocalDB(
    operationWorkflows // : OperationWorkflow[]
  ) {
    await db[TABLE_NAMES.OPERATION_WORKFLOWS].clear();
    return await db[TABLE_NAMES.OPERATION_WORKFLOWS].bulkPut(
      operationWorkflows
    );
  }

  // ENTERPRISE_FORMS
  async getEnterpriseFormsFromLocalDB() {
    return await db[TABLE_NAMES.ENTERPRISE_FORMS].toArray();
  }

  async setEnterpriseFormsToLocalDB(
    enterpriseForms // : EnterpriseForm[]
  ) {
    await db[TABLE_NAMES.ENTERPRISE_FORMS].clear();
    return await db[TABLE_NAMES.ENTERPRISE_FORMS].bulkPut(enterpriseForms);
  }

  // ENTERPRISE_WORKFLOWS
  async getEnterpriseWorkflowsFromLocalDB() {
    return await db[TABLE_NAMES.ENTERPRISE_WORKFLOWS].toArray();
  }

  async setEnterpriseWorkflowsToLocalDB(
    enterpriseWorkflows // : EnterpriseWorkflow[]
  ) {
    await db[TABLE_NAMES.ENTERPRISE_WORKFLOWS].clear();
    return await db[TABLE_NAMES.ENTERPRISE_WORKFLOWS].bulkPut(
      enterpriseWorkflows
    );
  }
}

export default new OperationLocalDbService();
